import * as React from "react";
import { cn } from "@/lib/utils";

type ContainerProps = {
  className?: string;
} & React.PropsWithChildren;

/** Centred page column with a real side gutter (16px on phones, 24px from sm). */
const Container: React.FC<ContainerProps> = ({ className, children }) => {
  return (
    <div className={cn("mx-auto w-full max-w-5xl px-4 sm:px-6", className)}>
      {children}
    </div>
  );
};

export default React.memo(Container);
